import { GridStack } from 'gridstack'
import { ComponentThumbnail } from './ComponentThumbnail.js'

const CANVAS_GRID_COLUMNS = 96

function getCollectionItems(el) {
  // Canvas chrome routes (workspace, wildcard, etc.) live on `context.pages`
  // so smbls' router can find them. The Collection thumbnails must only
  // show the LOADED PROJECT's pages — read them from `context.projectPages`
  // to avoid recursive thumbnails of the canvas itself.
  const pages = el.context?.projectPages || {}
  return Object.entries(pages).map(([key, v]) => ({
    value: v,
    key,
    type: 'pages',
    title: key,
    settings: { gridOptions: { w: 3, h: 3 } }
  }))
}

function generateGrid(n) {
  const obj = {
    '& > .grid-stack-item': { width: `${100 / n}%` },
    '& > .grid-stack-item[gs-x="1"]': { left: `${100 / n}%` }
  }
  for (let i = 1; i <= n; i++) {
    const pct = `${(100 / n) * i}%`
    obj[`& > .grid-stack-item[gs-w="${i}"]`] = { width: pct }
    obj[`& > .grid-stack-item[gs-x="${i}"]`] = { left: pct }
  }
  return obj
}

export const CANVAS_GRID_COLUMNS_COUNT = CANVAS_GRID_COLUMNS

export const Collection = {
  tag: 'div',
  minWidth: '100%',
  minHeight: '1618em',
  class: 'grid-stack',

  style: {
    [`&.gs-${CANVAS_GRID_COLUMNS}`]: generateGrid(CANVAS_GRID_COLUMNS)
  },

  childExtends: ComponentThumbnail,
  childrenAs: 'state',
  childProps: {},
  preventContentRecreate: true,
  children: (el) => getCollectionItems(el),

  onRender: (el) => {
    if (el.__gridInitialized) return
    el.__gridInitialized = true

    const gs = el.context?.globalScope
    setTimeout(() => {
      const gridInst = GridStack.addGrid(el.node, {
        column: CANVAS_GRID_COLUMNS,
        float: true,
        margin: '6.235em',
        resizable: { handles: 'all' }
      })
      gs.gridStackInstance = gridInst

      // Forward mouse events from iframe doc to parent for GridStack drag
      const iframeDoc = el.node.ownerDocument
      if (iframeDoc !== document) {
        const forward = (e) =>
          document.dispatchEvent(new e.constructor(e.type, e))
        iframeDoc.addEventListener('mousemove', forward, {
          capture: true,
          passive: true
        })
        iframeDoc.addEventListener('mouseup', forward, true)
      }

      gridInst.on('change', (event, items) => {
        if (items) gs.gridChanged = items
      })
    }, 50)
  }
}
